import {useOutletContext} from "react-router-dom";

import {HolderService} from "holder/service";
import {usePermitsSummaryTable} from "permit/data";
import {useViolationsSummaryTable} from "violation/data";
import {usePlantationsSummaryTable} from "plantation/data";

import {EntityViewSubPage} from "base/entity/components/container";
import {LinkedEntitySection} from "base/entity/components/presentational";

const ViewHolderProceduresSubPage = () => {
    const {tableColumns: permitTableColumns} = usePermitsSummaryTable();
    const {tableColumns: violationsTableColumns} = useViolationsSummaryTable();
    const {tableColumns: plantationsTableColumns} = usePlantationsSummaryTable();

    const context = useOutletContext();
    const holder = context[0];

    const entitiesData = [
        {
            entityName: "Autorizações",
            getItems: HolderService.getPermits,
            tableColumns: permitTableColumns,
        },
        {
            entityName: "Infracções",
            getItems: HolderService.getViolations,
            tableColumns: violationsTableColumns,
        },
        {
            entityName: "Plantios",
            getItems: HolderService.getPlantations,
            tableColumns: plantationsTableColumns,
        },
    ];

    const sections = [
        ...entitiesData.map((section, index) => (
            <LinkedEntitySection
                key={index}
                entityId={holder?.id}
                linkedEntityName={section.entityName}
                getItems={section.getItems}
                tableColumns={section.tableColumns}
            />
        )),
    ];

    return holder && <EntityViewSubPage sections={sections} />;
};

export default ViewHolderProceduresSubPage;
